import React, { Component } from "react";
import { Form, Spinner } from "react-bootstrap";
import { BaseUrl, Authorization, LogoutFunction } from "../static.js";

const mobileRegex = RegExp(/09(0[1-9]|1[0-9]|2[1-9]|3[0-9]|9[0-9])-?[0-9]{7}/);

export default class MobilePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileErrorText: "",
      mobileValue: "",
      buttonText: true,
      buttonSpinner: false,
      buttonDisabled: false,
      actionError: "",
    };
    this.mobileHandleChange = this.mobileHandleChange.bind(this);
    this.onLogin = this.onLogin.bind(this);
    this.mobileInput = React.createRef();
  }

  componentDidMount() {
    this.props.onMobileLoad();
    this.mobileInput.current.focus();
  }

  handleKeyPress(target) {
    if (target.charCode === 13) {
      this.onLogin();
    }
  }

  mobileHandleChange(event) {
    let telephone = event.target.value;
    if (telephone !== "0" && telephone !== "") {
      if (!Number(telephone)) {
        return;
      }
    }

    this.setState({ mobileValue: event.target.value });

    // if (event!==undefined) this.setState({mobileValue: event});
    // else this.setState({mobileValue: ''});
  }

  onLogin() {
    // let country='';
    // let number='';
    // if (isValidPhoneNumber(this.state.mobileValue) && isPossiblePhoneNumber(this.state.mobileValue)){
    //     let numberInfo=parsePhoneNumber(this.state.mobileValue);
    //     country=numberInfo.country;
    //     number=numberInfo.number;
    //     this.setState({actionError:''})
    // }else{
    //     this.setState({actionError:'incorrect number. please enter your number with country code'})
    //     return;
    // }

    if (this.state.mobileValue.length < 1) {
      this.setState({ actionError: "لطفاً شماره تلفن همراه را وارد کنید" });
      return;
    } else {
      this.setState({ actionError: "" });
    }

    if (mobileRegex.test(this.state.mobileValue)) {
      this.setState({ actionError: "" });
    } else {
      this.setState({ actionError: "شماره تلفن همراه وارد شده معتبر نیست" });
      return;
    }

    this.setState({
      buttonText: false,
      buttonSpinner: true,
      buttonDisabled: true,
    });

    let newmobile = this.state.mobileValue;
    if (newmobile.startsWith("0")) {
      newmobile = newmobile.substring(1);
      newmobile = "+98" + newmobile;
    }

    let data = {
      mobile: newmobile,
      country: "IR",
    };
    // data = Object.assign(data, Authorization());

    fetch(BaseUrl + "checkUser", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          sessionStorage.setItem("mobile", newmobile);
          this.props.onSubmitMobile();
          this.props.history.push(this.props.match.path + "/Password");
        } else if (result.status === 404) {
          console.log(result);
          sessionStorage.setItem("mobile", newmobile);
          sessionStorage.setItem("userStatus", "signup");
          this.props.onSubmitMobile();
          this.props.history.push(this.props.match.path + "/ValidationCode");
        } else {
          this.setState({
            buttonText: true,
            buttonSpinner: false,
            buttonDisabled: false,
            actionError:
              "اتصال با سرور با مشکل مواجه شد. از اتصال دستگاه به اینترنت اطمینان حاصل فرمائید.",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  render() {
    return (
      <div className="MobilePage">
        <Form.Control
          maxLength="11"
          className={
            this.state.actionError !== ""
              ? "inputStyle inputStyleError"
              : "inputStyle"
          }
          style={{ direction: "ltr" }}
          placeholder="شماره تلفن همراه خود را وارد کنید"
          type="tel"
          name="mobile"
          id="mobile"
          onChange={this.mobileHandleChange}
          value={this.state.mobileValue}
          disabled={this.state.buttonDisabled}
          onKeyPress={this.handleKeyPress.bind(this)}
          ref={this.mobileInput}
        />
        {/* <Input
                    className="inputStyle mobileInput"
                    placeholder="Mobile number with country code"
                    type="tel"
                    name="mobile"
                    id="mobile"
                    onChange={(this.mobileHandleChange)}
                    value={this.state.mobileValue}
                    disabled={this.state.buttonDisabled}
                    onKeyPress={this.handleKeyPress.bind(this)}
                    ref={this.mobileInput}
                /> */}
        <div className="errorMessageContainer">{this.state.actionError}</div>

        {!this.state.buttonDisabled && (
          <div
            onClick={
              this.state.buttonDisabled
                ? (event) => event.preventDefault()
                : this.onLogin
            }
            className="linkStyle"
          >
            ورود / ثبت نام
          </div>
        )}
        {this.state.buttonDisabled && (
          <Spinner
            style={{
              color: "var(--brown)",
              height: "20px",
              width: "20px",
              marginTop: "20px",
            }}
            animation="border"
          />
        )}

        {/* <PhoneInput
                placeholder="Please enter your phone number"
                value={this.state.mobileValue}
                onChange={(value)=>{this.setState({mobileValue: value});}}
                /> */}
        {/* Is possible: {this.state.mobileValue && isPossiblePhoneNumber(this.state.mobileValue) ? 'true' : 'false'}
                Is valid: {this.state.mobileValue && isValidPhoneNumber(this.state.mobileValue) ? 'true' : 'false'}
                National: {this.state.mobileValue && formatPhoneNumber(this.state.mobileValue)}
                International: {this.state.mobileValue && formatPhoneNumberIntl(this.state.mobileValue)} */}
      </div>
    );
  }
}
